<app-section class="section" [flat]="flat">
    <div class="card__title">
        <ng-content select="[header]"></ng-content>
    </div>
    <mat-divider></mat-divider>
    <div class="card__body">
        <ng-content select="[body]"></ng-content>
    </div>
</app-section>
